import { Divider } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";

function PreAuthLayout() {
  return (
    <div>
      <Navbar authenticated={false} />
      <Divider />
      <Outlet />
    </div>
  );
}

export default PreAuthLayout;
